import { GLOBAL_SETTINGS_STORAGE_KEY } from "~/helpers/consts";

export type GlobalSettings = {
  isSidebarOpen?: boolean;
  isDashboardSidebarOpen?: boolean;
  pageTableCompactView?: boolean;
  themePreference?: "light" | "dark" | "system";
};

export function getGlobalSettings(): GlobalSettings {
  try {
    const raw = localStorage.getItem(GLOBAL_SETTINGS_STORAGE_KEY);

    return raw ? (JSON.parse(raw) as GlobalSettings) : {};
  } catch {
    return {};
  }
}

export function setGlobalSettings(patch: Partial<GlobalSettings>) {
  const prev = getGlobalSettings();
  const next = { ...prev, ...patch };
  localStorage.setItem(GLOBAL_SETTINGS_STORAGE_KEY, JSON.stringify(next));

  return next;
}

// Currently, we never clear
export function clearGlobalSettings() {
  localStorage.removeItem(GLOBAL_SETTINGS_STORAGE_KEY);
}
